import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import AuthShell from '../components/auth/AuthShell';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';

const ForgotPassword = () => {
  const { forgotPassword } = useAuth();
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await forgotPassword(email);
      toast({ title: 'Check your inbox', description: res.message });
      setSent(true);
    } catch (err) {
      toast({ title: 'Something went wrong', description: err?.response?.data?.detail || 'Try again shortly.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset Your Password"
      subtitle="We’ll send you a link to set a new password."
      footer={<Link to="/login" className="text-mahogany font-medium hover:underline">Back to sign in</Link>}
    >
      {sent ? (
        <div className="p-6 rounded-2xl bg-rose-soft/60 border border-rose/60">
          <p className="font-serif-display text-xl text-burgundy">Email sent</p>
          <p className="mt-2 text-mahogany/80 text-sm">If an account exists for {email}, you’ll receive a reset link shortly.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.2em] text-mahogany/80 mb-2">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-mahogany/30 pb-3 pt-1 text-burgundy focus:outline-none focus:border-mahogany transition-colors" />
          </label>
          <button type="submit" disabled={loading} className="pill-btn justify-center w-full">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send Reset Link
          </button>
        </form>
      )}
    </AuthShell>
  );
};

export default ForgotPassword;
